<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[jobs$]"></ef-loading-container>
<ef-indirect-jobs-presenters
    [jobs]="jobs"
    [paycodes]="paycodes$ | async"
    [indirectTypes]="indirectTypes$ | async"
    [userGroups]="userGroups$ | async"
    [process]="process$ | async"
    [accounts]="accounts$ | async"
    [errors]="errors$ | async"
    [selectedError]="selectedError$ | async"
    (ShowError)="OnShowError($event)"
    (GetAccounts)="OnGetAccounts($event)"
>
</ef-indirect-jobs-presenters>
